module.exports = __webpack_public_path__ + "img/ic-play.5722c352.svg";